
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

//*MUI
import { Box, Checkbox, Divider } from '@mui/material';

//*files
import cssClasses from './SustenanceSales.module.css';

//*Redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../Redux Store/actions';
import Button from '../../../Subcomponents/Button';
import { errorTost, successTost } from '../../../Services/Toast';
import {
  DeleteSelectedSales,
  DeleteSelectedSalesForFloors,
  DeleteSelectedSalesForWings,
  getAllUnitsByProjectId,
  getAllUnitsByWingId,
  getAllUsers,
  getAllUsersForSustenance,
  getAllWingsByProjectId,
  getProjectByProjectName,
  getWingsIdByWingName,
  SalesRelationsData,
  SaveSelectedUsers,
  SaveSelectedUsersForFloors,
  SaveSelectedUsersForWings,
} from '../../../Services/SustenanceService';
import { cloneDeep, differenceWith, groupBy, isEqual, sortBy, uniqBy } from 'lodash';
import { dismissLoader, presentLoader } from '../../../Services/loader';
import { getAllSales } from '../../../Services/Sales';
import {
  getAllSalesByLaunch,
  getAllSalesByProject,
  getAllSalesByProjectFloors,
  getAllSalesByProjectWings,
} from '../../../Services/Launch';
import SelectSalesCp from '../../SelectSalesCp/SelectSalesCp';
import WingsIcon from '../../../Assets/Images/Common/noProjectFound.svg';
import {
  setAlotSustananceGlobalUnitAvailable,
  getAlotSustananceGlobalRoute,
} from '../../../Services/StoredSessionData';
import ArrowRight from '../../../Assets/Images/Common/RightArrow.svg'

import { DataGrid } from '@mui/x-data-grid';
import Datagrid from '../../../Subcomponents/Datagrid';
import ArrowBack from "@mui/icons-material/ArrowBack";
function SustenanceSales() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { projectId } = useParams();
  const [allSales, setAllSales] = useState([]);
  const [allChildSales, setAllChildSales] = useState([]);
  const [allSalesManager, setAllSalesManager] = useState([])
  const [searchSales, setSearchSales] = useState('');
  const [NoWingsFound, setNoWingsFound] = useState(null);
  const [AllWings, setAllWings] = useState([]);
  const [AllFloors, setAllFloors] = useState([]);
  const [TotalUnits, setTotalUnits] = useState(0);
  const [flag, setFlag] = useState(0)
  const [Units, setUnits] = useState([]);
  const [projectWingID, setProjectWingID] = useState();
  const [projectWingName, setProjectWingName] = useState();
  const [projectFloorName, setProjectFloorName] = useState();
  const smAccess = useRef("");
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedWingsRows, setSelectedWingsRows] = useState([]);


  useEffect(() => {
    dispatch(action.activeMenu('sales'));
    getProjectData();
  }, []);

  function getProjectData() {
    getProjectByProjectName(projectId)
      .then((resp) => {

        if (resp.data[0]) {
          setProjectName(resp.data[0]);
          smAccess.current = resp.data[0].smAccess
          getAllWingsByProjectId(projectId)
            .then((res) => {
              const Data = uniqBy(res.data, 'wingId.wingId');
              if (Data.length > 0) {
                setNoWingsFound(true);
              } else {
                setNoWingsFound(false);
              }
              const dataWing = Data.map((e) => {
                return e.wingId
              })
              setAllWings(dataWing);
            })
            .catch((err) => {
              console.error('getAllWingsByProjectId', err);
            });

          getAllUnitsByProjectId(projectId)
            .then((response) => {
              setTotalUnits(response.count);
            })
            .catch((err) => {
              console.error('getAllUnitsByProjectId', err);
            });
          // AllSaleManager();
        }

      })
      .catch((err) => {
        console.error('getProjectByProjectName', err);
      });

  }

  function updateSalesVisibility(salesArray, name, showValue) {
    return salesArray.map((e) =>
      e.name === name ? { ...e, show: showValue } : e
    );
  }
  const processSalesDataForProject = async (projectId, resp) => {
    try {
      const res = await getAllSalesByProject(projectId);

      if (res.data.length > 0) {
        res.data.forEach((ele, index) => {
          const salesIndex = resp.data.findIndex((e) => e.userId === ele.userId);
          if (salesIndex !== -1) {
            resp.data[salesIndex].isSelected = true;
          }
          resp.data = sortBy(resp.data, (o) => !o.isSelected);
          let newarr = cloneDeep(resp.data);
          if (index === res.data.length - 1) {
            setAllChildSales([...resp.data]);
            setAllSales([...newarr]);
            dismissLoader();
          }
        });
      } else {
        let newarr = cloneDeep(resp.data);
        setAllChildSales([...resp.data]);
        setAllSales([...newarr]);
        dismissLoader();
      }
    } catch (err) {
      console.error("Error processing sales data:", err);
      let newarr = cloneDeep(resp.data);
      setAllChildSales([...resp.data]);
      setAllSales([...newarr]);
      dismissLoader();
    }
  };
  const processSalesDataForWings = async (projectId, resp) => {
    try {

      const res = projectWingID ? await getAllSalesByProjectWings(projectId, projectWingID) : [];

      if (res.data.length > 0) {
        res.data.forEach((ele, index) => {
          const salesIndex = resp.data.findIndex((e) => e.userId === ele.userId);

          if (salesIndex !== -1) {
            resp.data[salesIndex].isSelected = false;
          } else {
            resp.data[salesIndex].isSelected = true;
          }
          resp.data = sortBy(resp.data, (o) => !o.isSelected);
          let newarr = cloneDeep(resp.data);
          if (index === res.data.length - 1) {
            setAllChildSales([...resp.data]);
            setAllSales([...newarr]);
            dismissLoader();
          }
        });
      } else {
        let newarr = cloneDeep(resp.data);
        setAllChildSales([...resp.data]);
        setAllSales([...newarr]);
        dismissLoader();
      }
    } catch (err) {
      console.error("Error processing sales data:", err);
      let newarr = cloneDeep(resp.data);
      setAllChildSales([...resp.data]);
      setAllSales([...newarr]);
      dismissLoader();
    }
  };
  const processSalesDataForFloors = async (projectId, resp) => {
    try {
      const res = projectFloorName ? await getAllSalesByProjectFloors(projectId, projectWingID, projectFloorName) : [];

      if (res.data.length > 0) {
        res.data.forEach((ele, index) => {
          const salesIndex = resp.data.findIndex((e) => e.userId === ele.userId);
          if (salesIndex !== -1) {
            resp.data[salesIndex].isSelected = true;
          }
          resp.data = sortBy(resp.data, (o) => !o.isSelected);
          let newarr = cloneDeep(resp.data);
          if (index === res.data.length - 1) {
            setAllChildSales([...resp.data]);
            setAllSales([...newarr]);
            dismissLoader();
          }
        });
      } else {
        let newarr = cloneDeep(resp.data);
        setAllChildSales([...resp.data]);
        setAllSales([...newarr]);
        dismissLoader();
      }
    } catch (err) {
      console.error("Error processing sales data:", err);
      let newarr = cloneDeep(resp.data);
      setAllChildSales([...resp.data]);
      setAllSales([...newarr]);
      dismissLoader();
    }
  };

  useEffect(() => {
    if (allSales.length === 0) {
      presentLoader();
      // AllSaleManager();
      getAllSales()
        .then((resp) => {
          resp.data.forEach((ele, index) => {
            ele.id = ele.userId;
            ele.show = true;
            ele.index = index;
            ele.isSelected = false;
          });
          setAllSalesManager(resp.data);
          smAccess.current === "Wings" ? processSalesDataForWings(projectId, resp) : smAccess.current === "Floors" ? processSalesDataForFloors(projectId, resp) : processSalesDataForProject(projectId, resp);
        })
        .catch((err) => {
          dismissLoader();
        });
    } else {
      let updatedAllSales = [...allSales];
      let updatedAllChildSales = [...allChildSales];
      if (searchSales === '') {
        allChildSales.forEach((e, index) => {
          setAllChildSales((pre) => {
            pre[index].show = true;
            return [...pre];
          });
        });
        allSales.forEach((e, index) => {
          setAllSales((pre) => {
            pre[index].show = true;
            return [...pre];
          });
        });
      } else {
        allSales.forEach((ele) => {
          const isMatching = ele.name.toUpperCase().includes(searchSales.toUpperCase());

          if (!isMatching) {
            updatedAllSales = updateSalesVisibility(updatedAllSales, ele.name, false);
            updatedAllChildSales = updateSalesVisibility(updatedAllChildSales, ele.name, false);
          } else {
            updatedAllSales = updateSalesVisibility(updatedAllSales, ele.name, true);
            updatedAllChildSales = updateSalesVisibility(updatedAllChildSales, ele.name, true);
          }

        });
        setAllSales(updatedAllSales);
        setAllChildSales(updatedAllChildSales);
        setAllChildSales(
          sortBy(updatedAllChildSales, [
            function (o) {
              return !o.isSelected;
            },
          ])
        );
      }
    }
  }, [searchSales]);

  const [projectName, setProjectName] = useState('');

  const salesGridColumns = [
    {
      field: 'name',
      headerName: 'Name',
      width: 400,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
            }}
          >
            <div>
              <Checkbox
                checked={params.row?.isSelected}
                onChange={(e) => {
                  setAllChildSales((prev) => {
                    const index = prev.findIndex((user) => user.id === params.row.id);
                    if (index === -1) return prev;
                    const updatedUser = { ...prev[index], isSelected: !prev[index].isSelected };
                    return [
                      ...prev.slice(0, index),
                      updatedUser,
                      ...prev.slice(index + 1),
                    ];
                  });

                  setAllSales((prevSelected) => {
                    const user = allSales.find((u) => u.id === params.row.id);
                    if (!user) return prevSelected;
                    return prevSelected;
                  });
                }}

              />
            </div>
            <div>
              <p>{params.row.name}</p>
            </div>
          </div>
        );
      },
    },
    {
      field: 'email',
      headerName: 'Mail Id',
      width: 250,
    },
    {
      field: 'contactNumber',
      headerName: 'Contact Number',
      width: 250,
    },
  ];

  function SaveUsers() {

    let allExistingSales = allSales.filter((e) => {
      return e.isSelected === true;
    });

    let arr = allChildSales.filter((e) => {
      return e.isSelected === true;
    });
    if (arr.length === 0) {
      let newarr = cloneDeep(allSales);
      setAllChildSales([...newarr]);
      errorTost('Please select atleast one Sales person and then save');
    } else {
      let newarr = cloneDeep(allChildSales);
      setAllSales([...newarr]);
      presentLoader();

      smAccess.current === "Wings" ? SaveProjectWingsSM(allExistingSales, arr) : smAccess.current === "Floors" ? SaveProjectFloorsSM(allExistingSales, arr) : SaveProjectSM(allExistingSales, arr);

    }
  }

  const SaveProjectWingsSM = async (allExistingSales, arr) => {
    if (allExistingSales.length > 0) {
      let insertarr = differenceWith(arr, allExistingSales, isEqual);
      let deletearr = differenceWith(allExistingSales, arr, isEqual);


      if (insertarr.length > 0) {
        insertarr.forEach((element, index) => {
          SaveSelectedUsersForWings({
            projectId: projectId,
            userId: element.userId,
            wingId: projectWingID
          }).then((resp) => {
            setAllSales((pre) => {
              pre[
                pre.findIndex((e) => e.userId === element.userId)
              ].isSelected = true;
              return [...pre];
            });
            if (index === insertarr.length - 1) {
              if (deletearr.length > 0) {
                deletearr.forEach((ele, index2) => {
                  DeleteSelectedSalesForWings(projectId, ele, projectWingID).then((res) => {
                    if (index2 === deletearr.length - 1) {

                      setAllSales((pre) => {
                        return pre.map((sale) =>
                          sale.userId === ele?.userId ? { ...sale, isSelected: false } : sale
                        );
                      });
                      successTost('Sales Team saved successfully');

                      setSearchSales('');
                      dismissLoader();
                    }
                  });
                });
              } else {
                successTost('Sales Team saved successfully');
                setSearchSales('');
                dismissLoader();
              }
            }
          });
        });
      }
      if (deletearr.length > 0) {

        deletearr.forEach((element, index2) => {
          DeleteSelectedSalesForWings(projectId, element, projectWingID).then((res) => {
            if (index2 === deletearr.length - 1) {
              setAllSales((pre) => {
                return pre.map((sale) =>
                  sale.userId === element?.userId ? { ...sale, isSelected: false } : sale
                );
              });
              successTost('Sales Team saved successfully');
              setSearchSales('');
              dismissLoader();
            }
          });
        });
      } else {
        successTost('Sales Team saved successfully');
        setSearchSales('');
        dismissLoader();
      }
    } else {
      arr.forEach((ele, index) => {
        if (selectedWingsRows.length > 0) {
          selectedWingsRows.map((wings) => {
            SaveSelectedUsersForWings({ projectId: projectId, userId: ele.userId, wingId: wings?.wingId }).then(
              (resp) => {
                setAllSales((pre) => {
                  pre[
                    pre.findIndex((e) => e.userId === ele.userId)
                  ].isSelected = true;
                  return [...pre];
                });
              }
            );
          })

        } else {
          SaveSelectedUsersForWings({ projectId: projectId, userId: ele.userId, wingId: projectWingID }).then(
            (resp) => {
              setAllSales((pre) => {
                pre[
                  pre.findIndex((e) => e.userId === ele.userId)
                ].isSelected = true;
                return [...pre];
              });
            }
          );
        }
        if (index === arr.length - 1) {
          successTost('Sales Team saved successfully');
          setSearchSales('');

        }
      });
      dismissLoader();
    }
  }
  const SaveProjectFloorsSM = async (allExistingSales, arr) => {
    if (allExistingSales.length > 0) {
      let insertarr = differenceWith(arr, allExistingSales, isEqual);
      let deletearr = differenceWith(allExistingSales, arr, isEqual);

      if (insertarr.length > 0) {
        insertarr.forEach((element, index) => {

          SaveSelectedUsersForFloors({
            projectId: projectId,
            userId: element.userId,
            wingId: projectWingID,
            floorNo: projectFloorName
          }).then((resp) => {
            setAllSales((pre) => {
              pre[
                pre.findIndex((e) => e.userId === element.userId)
              ].isSelected = true;
              return [...pre];
            });
            if (index === insertarr.length - 1) {
              if (deletearr.length > 0) {
                deletearr.forEach((ele, index2) => {
                  DeleteSelectedSalesForFloors(projectId, ele, projectWingID, projectFloorName).then((res) => {
                    if (index2 === deletearr.length - 1) {
                      setAllSales((pre) => {
                        return pre.map((sale) =>
                          sale.userId === ele?.userId ? { ...sale, isSelected: false } : sale
                        );
                      });
                      successTost('Sales Team saved successfully');

                      setSearchSales('');
                      dismissLoader();
                    }
                  });
                });
              } else {
                successTost('Sales Team saved successfully');
                setSearchSales('');
                dismissLoader();
              }
            }
          });
        });
      } else if (deletearr.length > 0) {
        deletearr.forEach((ele, index2) => {
          DeleteSelectedSalesForFloors(projectId, ele, projectWingID, projectFloorName).then((res) => {
            if (index2 === deletearr.length - 1) {
              setAllSales((pre) => {
                return pre.map((sale) =>
                  sale.userId === ele?.userId ? { ...sale, isSelected: false } : sale
                );
              });
              successTost('Sales Team saved successfully');
              setSearchSales('');
              dismissLoader();
            }
          });
        });
      } else {
        successTost('Sales Team saved successfully');
        setSearchSales('');
        dismissLoader();
      }
    } else {
      arr.forEach((ele, index) => {
        if (selectedRows.length > 0) {
          selectedRows.map((floors) => {
            SaveSelectedUsersForFloors({
              projectId: projectId, userId: ele.userId, wingId: projectWingID,
              floorNo: floors?.floorName
            }).then(
              (resp) => {
                setAllSales((pre) => {
                  return pre.map((sale) =>
                    sale.userId === ele?.userId ? { ...sale, isSelected: true } : sale
                  );
                });
              }
            );
          })
        } else {
          SaveSelectedUsersForFloors({
            projectId: projectId, userId: ele.userId, wingId: projectWingID,
            floorNo: projectFloorName
          }).then(
            (resp) => {
              setAllSales((pre) => {
                return pre.map((sale) =>
                  sale.userId === ele?.userId ? { ...sale, isSelected: true } : sale
                );
              });
            }
          );
        }
        if (index === arr.length - 1) {
          successTost('Sales Team saved successfully');
          setSearchSales('');
          dismissLoader();
        }
      });
    }

    dismissLoader();
  }
  const SaveProjectSM = (allExistingSales, arr) => {
    if (allExistingSales.length > 0) {
      let insertarr = differenceWith(arr, allExistingSales, isEqual);
      let deletearr = differenceWith(allExistingSales, arr, isEqual);

      if (insertarr.length > 0) {
        insertarr.forEach((element, index) => {
          SaveSelectedUsers({
            projectId: projectId,
            userId: element.userId,
          }).then((resp) => {
            setAllSales((pre) => {
              pre[
                pre.findIndex((e) => e.userId === element.userId)
              ].isSelected = true;
              return [...pre];
            });
            if (index === insertarr.length - 1) {
              if (deletearr.length > 0) {
                deletearr.forEach((ele, index2) => {
                  DeleteSelectedSalesForWings(ele, projectId).then((res) => {
                    if (index2 === deletearr.length - 1) {
                      setAllSales((pre) => {
                        pre[
                          pre.findIndex((e) => e.userId === element.userId)
                        ].isSelected = false;
                        return [...pre];
                      });
                      successTost('Sales Team saved successfully');

                      setSearchSales('');
                      dismissLoader();
                    }
                  });
                });
              } else {
                successTost('Sales Team saved successfully');
                setSearchSales('');
                dismissLoader();
              }
            }
          });
        });
      } else if (deletearr.length > 0) {
        deletearr.forEach((ele, index2) => {
          DeleteSelectedSales(ele, projectId).then((res) => {
            if (index2 === deletearr.length - 1) {
              setAllSales((pre) => {
                pre[
                  pre.findIndex((e) => e.userId === ele.userId)
                ].isSelected = false;
                return [...pre];
              });
              successTost('Sales Team saved successfully');
              setSearchSales('');
              dismissLoader();
            }
          });
        });
      } else {
        successTost('Sales Team saved successfully');
        setSearchSales('');
        dismissLoader();
      }
    } else {
      arr.forEach((ele, index) => {
        SaveSelectedUsers({ projectId: projectId, userId: ele.userId }).then(
          (resp) => {
            setAllSales((pre) => {
              pre[
                pre.findIndex((e) => e.userId === ele.userId)
              ].isSelected = true;
              return [...pre];
            });
            if (index === arr.length - 1) {
              successTost('Sales Team saved successfully');
              setSearchSales('');
              dismissLoader();
            }
          }
        );
      });
    }
  }
  function selectAll() {
    setAllChildSales((pre) => {
      return pre.map((ele) => ({
        ...ele,
        isSelected: true,
      }));
    });
  }


  function deSelectAll() {
    setAllChildSales((pre) => {
      return pre.map((ele) => ({
        ...ele,
        isSelected: false,
      }));
    });
  }


  async function goToProjectWing(wingId, wingName) {
    setProjectWingID(wingId);
    setProjectWingName(wingName);
    if (smAccess.current === "Wings") {
      try {
        const res = await getAllSalesByProjectWings(projectId, wingId);
        if (res.data.length > 0) {
          const selectedUserIds = new Set(res.data.map((ele) => ele.userId));
          const updatedSalesManager = allSalesManager.map((manager) => {
            return {
              ...manager,
              isSelected: selectedUserIds.has(manager.userId),
            };
          });
          updatedSalesManager.sort((a, b) => b.isSelected - a.isSelected);
          setAllChildSales(updatedSalesManager);
          setAllSales(updatedSalesManager);
        } else {
          setAllChildSales([...allSalesManager]);
          setAllSales([...allSalesManager]);

        }
      } catch (err) {
        console.error("Error fetching sales data:", err);
        setAllChildSales([...allSalesManager]);
        setAllSales([...allSalesManager]);
      } finally {
        dismissLoader();
      }
      setFlag(1);
    } else {

      await getAllUnitsByWingId(projectId, wingId).then((response) => {
        let _units = groupBy(response.data, 'unitId.floorNo');
        const dataFloors = sortBy(Object.keys(_units), (fl) => { return isNaN(parseInt(fl.split(' ')[1])) ? 0 : parseInt(fl.split(' ')[1]) }).map((name, index) => ({
          id: index + 1,
          floorName: name,
        }));
        setAllFloors(dataFloors)
        setUnits(_units);
        setTotalUnits(response.count);
        setFlag(2);
      }
      );
    }

  }

  async function goToProjectFloors(floorNo) {
    setFlag(1);
    setProjectFloorName(floorNo);
    allSalesManager.forEach((ele, index) => {
      ele.id = ele.userId;
      ele.show = true;
      ele.index = index;
      ele.isSelected = false;
    });
    try {
      const res = await getAllSalesByProjectFloors(projectId, projectWingID, floorNo);
      if (res.data.length > 0) {
        const updatedSalesManager = [...allSalesManager];
        for (const ele of res.data) {
          const index = updatedSalesManager.findIndex((e) => e.userId === ele.userId);
          if (index !== -1) {
            updatedSalesManager[index].isSelected = true;
          }
        }
        updatedSalesManager.sort((a, b) => b.isSelected - a.isSelected);

        // Update state (assuming a React-like state management)
        setAllChildSales(updatedSalesManager);
        setAllSales([...updatedSalesManager]);
      } else {
        // Handle case when no sales data is returned
        setAllChildSales([...allSalesManager]);
        setAllSales([...allSalesManager]);
      }
    } catch (err) {
      console.error("Error fetching sales data:", err);
      setAllChildSales([...allSalesManager]);
      setAllSales([...allSalesManager]);
    } finally {
      dismissLoader();
    }
  }

  const ProjectWingsColumns = [
    {
      field: 'wingName',
      headerName: 'Wing Name',
      width: 400,
      renderCell: (params) => {
        return (
          <Box
            className={cssClasses.SubContainer}
            style={{ cursor: 'pointer' }}
            onClick={() => goToProjectWing(params?.row?.wingId, params?.row?.wingName)}
          >
            {/* <img src={ProjectIcon} alt={''} /> */}
            <Box ml={1} mt={1} className={cssClasses.innerTitle}>
              {params?.row?.wingName ? params?.row?.wingName : ''}
            </Box>
          </Box>
        );
      },
    },
  ]
  const ProjectFloorsColumns = [
    {
      field: 'floorName',
      headerName: 'Floor Name',
      width: 400,
      renderCell: (params) => {
        return (
          <Box
            className={cssClasses.SubContainer}
            style={{ cursor: 'pointer' }}
            onClick={() => goToProjectFloors(params?.row?.floorName)}
          >
            {/* <img src={ProjectIcon} alt={''} /> */}
            <Box ml={1} mt={1} className={cssClasses.innerTitle}>
              {params?.row?.floorName ? params?.row?.floorName : ''}
            </Box>
          </Box>
        );
      },
    },
  ]

  const handleFloorSelectCheckbox = (newSelection) => {
    const selectedDataFloor = newSelection.map((id) =>
      AllFloors.find((row) => row.id === id)
    );
    setSelectedRows(selectedDataFloor);
  };
  const handleCheckboxFloorSM = () => {
    allSalesManager.forEach((ele, index) => {
      ele.id = ele.userId;
      ele.show = true;
      ele.index = index;
      ele.isSelected = false;
    });
    setFlag(3);
  }


  const handleWingsSelectCheckbox = (newSelection) => {
    const selectedDataWings = newSelection.map((id) =>
      AllWings.find((row) => row.wingId === id)
    );
    setSelectedWingsRows(selectedDataWings);
  };
  const handleCheckboxWingsSM = () => {
    allSalesManager.forEach((ele, index) => {
      ele.id = ele.userId;
      ele.show = true;
      ele.index = index;
      ele.isSelected = false;
    });

    setFlag(4);
  }
  return (<>
    <Box className={cssClasses.Container}>
      <Box padding={'2rem'}>
        <Box className={cssClasses.HeaderTitle}>{projectName?.projectName}</Box>
        <Box className={cssClasses.SubTitle}>
          {projectName?.addressLine1},{projectName?.addressLine2},
          {projectName?.addressLine3}
        </Box>
      </Box>

      <Divider variant='middle' />
      {
        flag === 0 && (smAccess.current === "Wings" || smAccess.current == "Floors"
          ? <Box overflow={'auto'} height={'100%'}>
            {
              smAccess.current === "Wings" ?
                <>
                  <Box
                    className={cssClasses.FlexRow}
                    marginTop={'2rem'}
                    padding={'0 2.4rem'}
                  >
                    <Box className={cssClasses.SubHeaderTitle}>Select Wings</Box>
                    <Box width={'fit-content'} marginLeft={'auto'} mr={2}>
                      <Button
                        style={{
                          color: "#fff",
                          backgroundColor: "#1570EF",
                          fontSize: "1.4rem",
                          lineHeight: "2rem",
                          fontFamily: "Roboto-Regular",
                        }}
                        padding={'0.8rem 2.6rem'}
                        disable={selectedWingsRows.length === 0}
                        btnName={'Go to sales manager'}
                        clicked={() => { handleCheckboxWingsSM() }}
                      />
                    </Box>
                  </Box>
                  <Box className={cssClasses.GridWrapper} padding={'0 2.4rem'}>
                    <Datagrid
                      rows={AllWings}
                      columns={ProjectWingsColumns}
                      getRowId={(row) => row.wingId}
                      checkBoxSelection
                      selectionModel={selectedWingsRows}

                      hideFooter={false}
                      selectedData={(newSelection) => handleWingsSelectCheckbox(newSelection)}
                    />
                  </Box>
                </>
                : <>
                  <Box
                    className={cssClasses.FlexRow}
                    marginTop={'2rem'}
                    padding={'0 2.4rem'}
                  >
                    <Box className={cssClasses.SubHeaderTitle}>Select Wings</Box>
                  </Box>
                  <Box className={cssClasses.GridWrapper} padding={'0 2.4rem'}>
                    <Datagrid
                      rows={AllWings}
                      columns={ProjectWingsColumns}
                      getRowId={(row) => row.wingId}
                    />
                  </Box>
                </>
            }
          </Box>
          : <Box overflow={'auto'} height={'100%'}>
            <Box
              className={cssClasses.FlexRow}
              marginTop={'2rem'}
              padding={'0 2.4rem'}
            >
              <Box className={cssClasses.SubHeaderTitle}>Select Sales Manager</Box>
              {loggedInUser?.roleId?.accessibleTabs?.Sustenance?.Sales[
                'Sales Manager Save'
              ]?.isAccessible && (
                  <Box width={'fit-content'} marginLeft={'auto'} mr={2}>
                    <Button
                      style={{
                        color: "#fff",
                        backgroundColor: "#1570EF",
                        fontSize: "1.4rem",
                        lineHeight: "2rem",
                        fontFamily: "Roboto-Regular",
                      }}
                      padding={'0.8rem 2.6rem'}
                      disable={allSales.length === 0}
                      btnName={'Save'}
                      clicked={SaveUsers}
                    />
                  </Box>
                )}
            </Box>

            <Box className={cssClasses.GridWrapper} padding={'0 2.4rem'}>
              <SelectSalesCp
                allChildRows={allChildSales}
                allRows={allChildSales?.filter((e) => {
                  return e.show === true;
                })}
                selectAll={selectAll} deSelectAll={deSelectAll}
                allColums={salesGridColumns}
                setSearchSalesCp={setSearchSales}
              />
            </Box>
          </Box>
        )
      }
      {
        flag === 1 &&
        <Box overflow={'auto'} height={'100%'}>
          <Box
            className={cssClasses.FlexRow}
            marginTop={'2rem'}
            padding={'0 2.4rem'}
          >
            <Box
              className={cssClasses.SubHeaderTitle}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "10px"  // Space between the button and other elements
              }}
            >
              <span
                style={{
                  cursor: "pointer",
                  padding: "0.8rem 3.6rem",
                  fontSize: "1.4rem",
                  color: "#344054",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => {
                  if (smAccess.current === "Wings") {
                    setFlag(0);
                  } else if (smAccess.current === "Floors") {
                    setFlag(2);
                  }
                }}
              >
                <ArrowBack style={{ width: "2rem", height: "2rem", color: "#000000", marginRight: "0.5rem" }} />
                Back
              </span>

              {` ${projectWingName}  `}
              <img src={ArrowRight} alt={'rightArrow'} />
              {smAccess.current === "Floors" && (
                <>
                  {` ${projectFloorName}  `}
                  <img src={ArrowRight} alt={'rightArrow'} />
                </>
              )}

              Select Sales Manager
            </Box>

            {loggedInUser?.roleId?.accessibleTabs?.Sustenance?.Sales[
              'Sales Manager Save'
            ]?.isAccessible && (
                <Box width={'fit-content'} marginLeft={'auto'} mr={2}>
                  <Button
                    style={{
                      color: "#fff",
                      backgroundColor: "#1570EF",
                      fontSize: "1.4rem",
                      lineHeight: "2rem",
                      fontFamily: "Roboto-Regular",
                    }}
                    padding={'0.8rem 2.6rem'}
                    disable={allSales.length === 0}
                    btnName={'Save'}
                    clicked={SaveUsers}
                  />
                </Box>
              )}
          </Box>

          <Box className={cssClasses.GridWrapper} padding={'0 2.4rem'}>
            <SelectSalesCp
              allChildRows={allChildSales}
              allRows={allChildSales?.filter((e) => {
                return e.show === true;
              })}
              selectAll={selectAll}
              deSelectAll={deSelectAll}
              allColums={salesGridColumns}
              setSearchSalesCp={setSearchSales}
            />
          </Box>
        </Box>
      }
      {
        flag === 2 && <Box overflow={'auto'} height={'100%'}>
          <Box
            className={cssClasses.FlexRow}
            marginTop={'2rem'}
            padding={'0 2.4rem'}
          >
            <Box className={cssClasses.SubHeaderTitle}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "10px"
              }}
            >
              <span
                style={{
                  cursor: "pointer",
                  padding: "0.8rem 3.6rem",
                  fontSize: "1.4rem",
                  color: "#344054",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => {
                  setFlag(0);
                }}
              >
                <ArrowBack
                  style={{ width: "2rem", height: "2rem", color: "#000000", marginRight: "0.5rem" }}  // Icon and margin to the right of it
                />
                Back
              </span>

              {`${projectWingName} `}<img src={ArrowRight} alt={'rightArrow'} /> Select Floors
            </Box>
            <Box width={'fit-content'} marginLeft={'auto'} mr={2}>
              <Button
                style={{
                  color: "#fff",
                  backgroundColor: "#1570EF",
                  fontSize: "1.4rem",
                  lineHeight: "2rem",
                  fontFamily: "Roboto-Regular",
                }}
                padding={'0.8rem 2.6rem'}
                disable={selectedRows.length === 0}
                btnName={'Go to sales manager'}
                clicked={() => { handleCheckboxFloorSM() }}
              />
            </Box>
          </Box>
          <Box className={cssClasses.GridWrapper} padding={'0 2.4rem'}>
            <Datagrid
              rows={AllFloors}
              columns={ProjectFloorsColumns}
              getRowId={(row) => row.id}
              checkBoxSelection
              selectionModel={selectedRows}
              // pageChanged={pageChanged} 
              hideFooter={false}
              selectedData={(newSelection) => handleFloorSelectCheckbox(newSelection)}
            />
          </Box>
        </Box>
      }

      {
        flag === 3 && <Box overflow={'auto'} height={'100%'}>
          <Box
            className={cssClasses.FlexRow}
            marginTop={'2rem'}
            padding={'0 2.4rem'}
          >
            <Box className={cssClasses.SubHeaderTitle}> {` ${projectWingName}  `}
              <img src={ArrowRight} alt={'rightArrow'} />Floors Selection <img src={ArrowRight} alt={'rightArrow'} />Select Sales Manager</Box>
            {loggedInUser?.roleId?.accessibleTabs?.Sustenance?.Sales[
              'Sales Manager Save'
            ]?.isAccessible && (
                <Box width={'fit-content'} marginLeft={'auto'} mr={2}>
                  <Button
                    style={{
                      color: "#fff",
                      backgroundColor: "#1570EF",
                      fontSize: "1.4rem",
                      lineHeight: "2rem",
                      fontFamily: "Roboto-Regular",
                    }}
                    padding={'0.8rem 2.6rem'}
                    disable={allSales.length === 0}
                    btnName={'Save'}
                    clicked={SaveUsers}
                  />
                </Box>
              )}
          </Box>

          <Box className={cssClasses.GridWrapper} padding={'0 2.4rem'}>
            <SelectSalesCp
              allChildRows={allChildSales}
              allRows={allChildSales?.filter((e) => {
                return e.show === true;
              })}
              selectAll={selectAll}
              deSelectAll={deSelectAll}
              allColums={salesGridColumns}
              setSearchSalesCp={setSearchSales}
            />
          </Box>
        </Box>
      }


      {
        flag === 4 && <Box overflow={'auto'} height={'100%'}>
          <Box
            className={cssClasses.FlexRow}
            marginTop={'2rem'}
            padding={'0 2.4rem'}
          >
            <Box className={cssClasses.SubHeaderTitle}> Wings Selection <img src={ArrowRight} alt={'rightArrow'} />Select Sales Manager</Box>
            {loggedInUser?.roleId?.accessibleTabs?.Sustenance?.Sales[
              'Sales Manager Save'
            ]?.isAccessible && (
                <Box width={'fit-content'} marginLeft={'auto'} mr={2}>
                  <Button
                    style={{
                      color: "#fff",
                      backgroundColor: "#1570EF",
                      fontSize: "1.4rem",
                      lineHeight: "2rem",
                      fontFamily: "Roboto-Regular",
                    }}
                    padding={'0.8rem 2.6rem'}
                    disable={allSales.length === 0}
                    btnName={'Save'}
                    clicked={SaveUsers}
                  />
                </Box>
              )}
          </Box>

          <Box className={cssClasses.GridWrapper} padding={'0 2.4rem'}>
            <SelectSalesCp
              allChildRows={allChildSales}
              allRows={allChildSales?.filter((e) => {
                return e.show === true;
              })}
              selectAll={selectAll}
              deSelectAll={deSelectAll}
              allColums={salesGridColumns}
              setSearchSalesCp={setSearchSales}
            />
          </Box>
        </Box>
      }
    </Box>
  </>
  );
}

export default SustenanceSales;
